import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedinIn, FaGithub, FaFacebookF, FaInstagram, FaAt, FaWhatsapp } from 'react-icons/fa';

const SocialFloat = () => {
  const socials = [
    { icon: <FaLinkedinIn />, href: "https://linkedin.com", color: "#0077b5", gradient: null, label: "LinkedIn" },
    { icon: <FaGithub />, href: "https://github.com", color: "#24292e", gradient: null, label: "GitHub" },
    { icon: <FaFacebookF />, href: "https://facebook.com", color: "#1877f2", gradient: "linear-gradient(to bottom, #18acfe, #0162e0)", label: "Facebook" },
    { icon: <FaInstagram />, href: "https://instagram.com", color: "#e4405f", gradient: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)", label: "Instagram" },
    { icon: <FaAt />, href: "https://threads.net", color: "#1a1a1a", gradient: null, label: "Threads" },
    { icon: <FaWhatsapp />, href: "https://wa.me/", color: "#25D366", gradient: null, label: "WhatsApp" },
  ];

  return (
    <div className="fixed left-4 sm:left-6 top-1/2 -translate-y-1/2 z-40 hidden md:flex flex-col gap-4 pointer-events-auto">
      {socials.map((social, index) => (
        <motion.a
          key={index}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 1.5 + index * 0.1 }}
          whileHover={{ x: 5 }}
          className="group relative flex items-center"
        >
          {/* Icon Circle */}
          <motion.div 
            whileHover={{ 
              backgroundColor: social.gradient ? 'transparent' : social.color,
              backgroundImage: social.gradient || 'none',
              borderColor: social.color,
              scale: 1.15,
              color: '#ffffff'
            }}
            className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 shadow-lg overflow-hidden group-hover:text-white"
            style={{
              backgroundColor: 'rgba(44, 69, 107, 0.4)',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              color: '#94a3b8'
            }}
          >
            <span className="relative z-10 text-base transition-colors duration-300">{social.icon}</span>
          </motion.div>
        </motion.a>
      ))}

      {/* Decorative Line with animated running glowing light beam */}
      <div className="relative w-[1.5px] h-20 bg-gradient-to-b from-[#4779c4]/40 via-[#4779c4]/20 to-transparent self-center mt-2 rounded-full overflow-hidden">
        {/* Slowly moving light pulse traveling down the line */}
        <motion.div
          animate={{
            y: [-30, 90],
            opacity: [0, 1, 1, 0],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="absolute left-0 w-full h-8 bg-gradient-to-b from-transparent via-[#60a5fa] to-transparent shadow-[0_0_8px_#38bdf8]"
        />
      </div>
    </div>
  );
};

export default SocialFloat;
